module.exports = __webpack_public_path__ + "static/media/amex.c75d61ec.png";